import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum,
  Modules,
  NonAuthRoutes
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import TransactionList from '../modules/transactions/list';
import TransactionAddEditView from '../modules/transactions/addEditView';

const Transactions: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={TransactionList} accessibleTo={[{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.view + RouteParamsTypes.id} element={<ProtectedRoute component={TransactionAddEditView} accessibleTo={[{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.add} element={<ProtectedRoute component={TransactionAddEditView} accessibleTo={[{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.Add] }]} />} />
      <Route path={RouteParamsTypes.edit + RouteParamsTypes.id} element={<ProtectedRoute component={TransactionAddEditView} accessibleTo={[{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.Update] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Transactions;
